import { useState, useEffect, useRef } from 'react';

interface CoinAnimation {
  show: boolean;
  value: number;
  isPositive: boolean;
}

export function useCoinAnimation(
  currentCoins: number
): CoinAnimation {
  const [animation, setAnimation] = useState<CoinAnimation>(
    {
      show: false,
      value: 0,
      isPositive: true,
    }
  );
  const previousCoinsRef = useRef<number | null>(null);
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    if (
      previousCoinsRef.current !== null &&
      currentCoins !== previousCoinsRef.current
    ) {
      const difference =
        currentCoins - previousCoinsRef.current;

      previousCoinsRef.current = currentCoins;

      // Skip the first 0→N transition (initial data load, not a real gain)
      if (!hasInitializedRef.current) {
        hasInitializedRef.current = true;
        return;
      }

      if (difference !== 0) {
        setAnimation({
          show: true,
          value: Math.abs(difference),
          isPositive: difference > 0,
        });

        const timer = setTimeout(() => {
          setAnimation(prev => ({ ...prev, show: false }));
        }, 420);

        return () => clearTimeout(timer);
      }
    } else {
      previousCoinsRef.current = currentCoins;
    }
  }, [currentCoins]);

  return animation;
}
